export default __webpack_public_path__ + "static/media/svg-2.9961f883.svg";